import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { t } from 'Utils/localization/i18next';
import analytics from 'Utils/analytics/analyticsWrapper';
import { getRedirectURLForDeleteProfile } from 'Redux/profile/profileThunks';
import { PROFILE_TYPES } from 'Redux/profile/profileConstants';
import { Text, H2, FlexPanel, Button } from 'Common';
import trashCan from '@ingka/ssr-icon/paths/trash-can';
import styles from './LoginSecurity.module.scss';

class DeleteAccountContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { showErrorMessage: false };
  }

  onDeleteClick = async e => {
    e.preventDefault();
    const redirectURL = await this.props.getRedirectURLForDeleteProfile();
    if (redirectURL) {
      analytics.userProfileFormUpdate({
        status: 'started',
        form: `${this.props.profileType}-dashboard-delete-account`
      });
      window.location = redirectURL;
    } else {
      this.setState({ showErrorMessage: true });
    }
  };

  render() {
    return (
      <div className={styles['dashboard-section-read']}>
        <FlexPanel spread className={styles['dashboard-section-read-title']}>
          <H2 headingSize="m" margin={false}>
            {t('dashboard.profile-details.deleteAccount.deleteTitle')}
          </H2>
          <Button
            className={styles['edit-link']}
            size="small"
            type="tertiary"
            onClick={this.onDeleteClick}
            ssrIcon={trashCan}
            href="#"
          >
            {t('dashboard.profile-details.deleteAccount.deleteLink')}
          </Button>
          <Button
            className={styles['edit-link-mobile']}
            onClick={this.onDeleteClick}
            aria-label={t('dashboard.profile-details.deleteAccount.deleteLink')}
            size="small"
            type="tertiary"
            ssrIcon={trashCan}
            iconOnly
            href="#"
          ></Button>
        </FlexPanel>
        <FlexPanel>
          <Text className={styles['dashboard-section-read-text']} tagName="p">
            {this.props.profileType === PROFILE_TYPES.FAMILY
              ? t('dashboard.profile-details.deleteAccount.deleteText')
              : t('dashboard.settings.deleteBodyRegular')}
          </Text>
        </FlexPanel>
      </div>
    );
  }
}

DeleteAccountContainer.propTypes = {
  profileType: PropTypes.string,
  getRedirectURLForDeleteProfile: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    profileType: state.profile.profileType
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getRedirectURLForDeleteProfile
    },
    dispatch
  );
};

const DeleteAccountWithConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteAccountContainer);

export default withRouter(DeleteAccountWithConnect);
